import {
  Box,
  Button,
  Chip,
  ListItem,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import {
  bookingSetCardDisplay,
  type BookingSetCardProps,
} from "@bw/shared/components";
import { Link as RouterLink } from "react-router-dom";

/** Player-native MUI renderer for a shared, truthful booking-set projection. */
export function MaterialBookingSetCard(props: BookingSetCardProps) {
  const display = bookingSetCardDisplay(props);

  return (
    <ListItem
      divider
      sx={{
        px: 2,
        py: 1.5,
        gap: 1.5,
        alignItems: { xs: "stretch", sm: "center" },
        flexDirection: { xs: "column", sm: "row" },
      }}
    >
      <ListItemText
        sx={{ minWidth: 0, m: 0 }}
        primary={
          <Stack
            component="span"
            direction="row"
            spacing={1}
            sx={{ alignItems: "center", minWidth: 0 }}
          >
            <Typography component="span" noWrap sx={{ fontWeight: 700 }}>
              {display.title}
            </Typography>
            <Chip
              component="span"
              label={display.countLabel}
              size="small"
              variant="outlined"
            />
          </Stack>
        }
        secondary={display.context || undefined}
      />

      <Stack
        direction="row"
        spacing={1.25}
        sx={{
          flexShrink: 0,
          alignItems: "center",
          justifyContent: { xs: "space-between", sm: "flex-end" },
        }}
      >
        <Box sx={{ textAlign: { sm: "right" } }}>
          <Typography variant="body2" sx={{ fontWeight: 700 }}>
            {display.totalLabel}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {display.state}
          </Typography>
        </Box>
        <Button
          component={RouterLink}
          to={display.detailHref}
          aria-label={display.detailAccessibleLabel}
          size="small"
        >
          View
        </Button>
      </Stack>
    </ListItem>
  );
}
